
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSkillPathwayQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"badgeTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"VerifiedSkills"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSkillPathwayByBadgeIdForCurrentUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"badgeTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"badgeTemplateId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"badgeTemplateId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"careerBand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skillAreasWithUserData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SkillPathway_SkillAreaWithUserData"},"directives":[]}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SkillPathway_SkillAreaWithUserData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiedSkills_SkillAreaWithUserData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skillArea"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SkillPathway_SkillArea"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SkillPathway_SkillArea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VerifiedSkills_SkillArea"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"course"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SkillPathway_SkillAreaCourse"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"skillExpressions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SkillPathway_SkillAreaCourse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Course_Course"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promoPhotoUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":692}};
    doc.loc.source = {"body":"query GetSkillPathwayQuery($badgeTemplateId: ID!) {\n  VerifiedSkills {\n    getSkillPathwayByBadgeIdForCurrentUser(badgeTemplateId: $badgeTemplateId) {\n      id\n      badgeTemplateId\n      careerBand\n      skillAreasWithUserData {\n        ...SkillPathway_SkillAreaWithUserData\n      }\n    }\n  }\n}\n\nfragment SkillPathway_SkillAreaWithUserData on VerifiedSkills_SkillAreaWithUserData {\n  skillArea {\n    ...SkillPathway_SkillArea\n  }\n}\n\nfragment SkillPathway_SkillArea on VerifiedSkills_SkillArea {\n  name\n  course {\n    ...SkillPathway_SkillAreaCourse\n  }\n  skillExpressions {\n    id\n    name\n  }\n}\n\nfragment SkillPathway_SkillAreaCourse on Course_Course {\n  id\n  promoPhotoUrl\n  name\n  slug\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetSkillPathwayQuery"] = oneQuery(doc, "GetSkillPathwayQuery");
        
        module.exports["SkillPathway_SkillAreaWithUserData"] = oneQuery(doc, "SkillPathway_SkillAreaWithUserData");
        
        module.exports["SkillPathway_SkillArea"] = oneQuery(doc, "SkillPathway_SkillArea");
        
        module.exports["SkillPathway_SkillAreaCourse"] = oneQuery(doc, "SkillPathway_SkillAreaCourse");
        
